<script setup>

import Card from "@/Components/Card.vue";
import {computed} from "vue";
import NavLink from "@/Components/NavLink.vue";
import {route} from "ziggy-js";

const props = defineProps({
    product: Object,
    selectedLot: Object,
})

const categories = computed(() => {
    return props.product.categories.map(item => item.title).join(', ');
})

const sellBtnText = computed(() => props.selectedLot?.title ?? props.product.title)

const heading = computed(() => props.selectedLot?.title ? `${props.product.title} ${props.selectedLot.title}` : props.product.title)

</script>

<template>
    <card class="px-2.5 py-2.5 pb-4 flex">
        <img :src="product.image_url" :alt="product.title" class="rounded-lg" style="width: 120px; height: 120px">
        <div class="!w-full min-w-0 flex flex-col justify-items-stretch justify-between">
            <div class="px-2.5 py-1.25 dark:text-slate-200 text-xs tracking-wider font-normal leading-120">
                {{ categories }}
            </div>
            <h1 class="px-2.5 py-1.25 dark:text-slate-200 text-xl tracking-wider font-bold leading-120">{{
                    heading
                }}
            </h1>
            <NavLink :href="$props.selectedLot ?
            route('lots.offers.create', {lot: $props.selectedLot.id}) : route('user.offers.selectLot', {product_id: $props.product.id})"
                     class="ml-1.5 px-1 py-2 inline-block rounded-lg max-w-max truncate text-sm text-green-600 hover:text-green-500 font-sans font-medium border border-green-600 hover:border-green-500 transition-all"
            >
                {{
                    $t('Sell :title', {
                        title: sellBtnText
                    })
                }}
            </NavLink>
        </div>
    </card>
</template>
